import type { BleDeviceInfo } from '@hunting-nature/Secacam/shared/interfaces/ble.interface';
import { createAction, props } from '@ngrx/store';

import { prefixed } from '../../../shared/utils/factory.utils';
import type { DeviceChallengeResponse } from '@hunting-nature/shared-core/interfaces/device-registration.interface';
import type { RegistrationError } from '../../../shared/services/device-api.service';

const action = prefixed('[Device Registration]');

export const DeviceRegistrationActions = {
  // Flow lifecycle
  openDeviceRegistrationFlow: createAction(action('Open device registration flow')),
  closeDeviceRegistrationFlow: createAction(action('Close device registration flow')),

  selectDeviceForRegistration: createAction(action('Select device for registration'), props<{ deviceId: string; serialNumber: string; modelName: string }>()),

  // Challenge request lifecycle
  requestChallengeSucceeded: createAction(action('Request challenge succeeded'), props<{ deviceId: string; challenge: DeviceChallengeResponse }>()),
  requestChallengeFailed: createAction(action('Request challenge failed'), props<{ error: RegistrationError }>()),

  // BLE proof collection lifecycle
  collectProofSucceeded: createAction(action('Collect proof succeeded'), props<{ deviceId: string; challengeId: string; deviceSignature: string }>()),
  collectProofFailed: createAction(action('Collect proof failed'), props<{ error: RegistrationError }>()),

  // Registration completion
  registrationSucceeded: createAction(action('Registration succeeded'), props<{ hardwareId: string }>()),
  registrationFailed: createAction(action('Registration failed'), props<{ error: RegistrationError; retryAfterMs?: number }>()),

  // Rate limit backoff
  rateLimitBackoffSet: createAction(action('Rate limit backoff set'), props<{ until: number }>()),
  rateLimitExpired: createAction(action('Rate limit expired')),

  // Retry safety
  resetRegistrationState: createAction(action('Reset registration state')),
};
